// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uploaded-photo {
  width: 120px;
  height: 160px;
  object-fit: contain;
  margin: 0px auto;
  display: block;
}

.uploaded-photo-container {
  margin: 10px 0;
  border: 1px solid #e0e0e0;
  padding: 5px 0 5px 0;
  border-radius: 5px;
  min-width: 196px;
  max-width: 196px;
}

.command-line {
  min-width: 196px;
  max-width: 196px;
  display: flex;
  gap: 10px;
}

.command-line button mat-icon {
  display: none;
}

.command-line button p {
  margin: 0;
  display: block;
}

.error-message {
  color: red;
}

@media (max-width: 640px), (max-height: 640px) {
  .uploaded-photo {
    width: 60px;
    height: 80px;
  }
  .uploaded-photo-container {
    min-width: 98px;
    max-width: 98px;
  }
  .command-line {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 5px;
    min-width: 98px;
    max-width: 98px;
  }
  .command-line button {
    min-width: 30px;
    display: flex;
    justify-content: center;
    padding: 0 18px;
  }
  .command-line button mat-icon {
    display: block;
    margin-right: 0;
  }
  .command-line button p {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/dev/photo-upload/photo-upload.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AACJ;;AACA;EACI,cAAA;EACA,yBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAEJ;;AAAA;EACI,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,SAAA;AAGJ;;AADA;EACI,aAAA;AAIJ;;AAFA;EACI,SAAA;EACA,cAAA;AAKJ;;AAHA;EACI,UAAA;AAMJ;;AAJA;EACI;IACI,WAAA;IACA,YAAA;EAON;EALE;IACI,eAAA;IACA,eAAA;EAON;EALE;IACI,aAAA;IACA,8BAAA;IACA,QAAA;IACA,eAAA;IACA,eAAA;EAON;EALE;IACI,eAAA;IACA,aAAA;IACA,uBAAA;IACA,eAAA;EAON;EALE;IACI,cAAA;IACA,eAAA;EAON;EALE;IACI,aAAA;EAON;AACF","sourcesContent":[".uploaded-photo {\n    width: 120px;\n    height: 160px;\n    object-fit: contain;\n    margin: 0px auto;\n    display: block;\n}\n.uploaded-photo-container {\n    margin: 10px 0;\n    border: 1px solid #e0e0e0;\n    padding: 5px 0 5px 0;\n    border-radius: 5px;\n    min-width: 196px;\n    max-width: 196px;\n}\n.command-line {\n    min-width: 196px;\n    max-width: 196px;\n    display: flex;\n    gap: 10px;\n}\n.command-line button mat-icon {\n    display: none;\n}\n.command-line button p {\n    margin: 0;\n    display: block;\n}\n.error-message {\n    color: red;\n}\n@media (max-width: 640px), (max-height: 640px) {\n    .uploaded-photo {\n        width: 60px;\n        height: 80px;\n    }\n    .uploaded-photo-container {\n        min-width: 98px;\n        max-width: 98px;\n    }\n    .command-line {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        gap: 5px;\n        min-width: 98px;\n        max-width: 98px;\n    }\n    .command-line button {\n        min-width: 30px;\n        display: flex;\n        justify-content: center;\n        padding: 0 18px;\n    }\n    .command-line button mat-icon {\n        display: block;\n        margin-right: 0;\n    }\n    .command-line button p {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
